import { createCRUDEndpoints } from '@/api/factory/crud';
import { ClinicalTrainingEventJSON } from '@/store/modules/clinical-training-events/clinical-training-event';
import { PublishStatus } from '@/store/types';
import httpClient from '@/api/http-client';
import { RequestConfig } from '../types';

export type ListParams = {
  name?: string;
  search?: string;
  status?: PublishStatus;
  page?: string | number;
  sort?: string;
  direction?: 'asc' | 'desc';
  products?: number[];
};

export type ActiveParams = {
  products?: string[];
};

export const {
  list,
  get,
  store,
  remove,
  restore,
} = createCRUDEndpoints<ClinicalTrainingEventJSON, ListParams>({
  slug: {
    base: 'clinical-training-events',
    list: 'clinical-training-events',
    get: 'clinical-training-event',
    store: 'clinical-training-event',
    remove: 'clinical-training-event'
  }
});

export function active(params?: ActiveParams, config?: RequestConfig) {
  return httpClient.get<ClinicalTrainingEventJSON[]>('clinical-training-events/active', { params, ...config });
}

export function subscribe(id: number, config?: RequestConfig) {
  return httpClient.post(`clinical-training-event/${id}/subscribe`, {}, config);
}

export function unsubscribe(id: number, config?: RequestConfig) {
  return httpClient.delete(`clinical-training-event/${id}/unsubscribe`, config);
}

export function listAll(
  params?: {
    search?: string;
    status?: PublishStatus;
    products?: number[];
  },
  config?: RequestConfig,
) {
  return httpClient.get<ClinicalTrainingEventJSON[]>('clinical-training-events/list', { params, ...config });
}
